export default __webpack_public_path__ + "static/media/slide6.5c4f6b3f.jpg";